import i18n from 'i18next';
import Backend from 'i18next-http-backend'; // 설정값을 resources path로부터 셋팅함.
import LanguageDetector from 'i18next-browser-languagedetector'; // 사용자 브라우저의 언어를 인식하여 해당 언어로 컨텐츠를 번역.
import { initReactI18next } from 'react-i18next'; // React용 i18next

import config from 'src/shared/config';
// import.meta.env.VITE_APP_TYPE
export const supportLanguages = [
  {
    key: 'ko',
    title: 'KR',
  },
  {
    key: 'en',
    title: 'EN',
  },
];
export const DEFAULT_LANGUAGE = localStorage.getItem('i18nextLng') || 'en';

const resourceNames = [
  'commons',
  'encMail',
  'error',
  'exchangeFull',
  'fileType',
  'userApproval',
  'userMenu',
  'userRequest',
  'userStatus',
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: 'all',
    backend: {
      loadPath: config.url('/locales/{{lng}}/{{ns}}.json'),
    },
    ns: resourceNames,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    supportedLngs: supportLanguages.map((key) => key.key),
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },
  });

export default i18n;

export function getLanguage(defaultLang?: string | null): string {
  return i18n.language || defaultLang || DEFAULT_LANGUAGE;
}

export function getFasooUiComponentLanguage(): 'ko' | 'en' {
  return getLanguage() === 'ko' ? 'ko' : 'en';
}
